<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Pagamenti</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-toolbar-items>
								<v-btn text :loading="billing" @click.prevent="runManualBilling">
									<v-icon left>mdi-cash-sync</v-icon>
									Esegui fatturazione
								</v-btn>
								<v-btn text @click.prevent="createItem">
									<v-icon left>mdi-plus</v-icon>
									Nuovo
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="searchfield"
										label="Cerca per riferimento, nome o email merchant"
										outlined
										append-icon="mdi-magnify"
										dense
										clearable
										hide-details
										@click:append="getSearch()"
										@keyup.enter="getSearch()"
										@click:clear="clearSearch()"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.status"
										:items="statusItems"
										item-text="text"
										item-value="value"
										label="Status"
										outlined
										dense
										clearable
										hide-details
									></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.billingType"
										:items="billingItems"
										item-text="text"
										item-value="value"
										label="Tipo"
										outlined
										dense
										clearable
										hide-details
									></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							:headers="headers"
							:items="getPayments"
							:options.sync="settings.options"
							:server-items-length="total"
							:loading="loading"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							class="elevation-0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="manage-payment-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :fields="campiCard(item)">
												<template v-slot:title>
													{{ item.code }}
													<span class="text-caption grey--text text--darken-1 ml-1">{{ item.auto ? 'Automatico' : 'Manuale' }}</span>
												</template>
												<template v-slot:actions>
													<v-icon v-if="item.mail && item.mail.sentAt" small color="success" class="mx-1" :title="mailTitle(item)">mdi-email-check</v-icon>
													<v-icon v-else-if="item.mail && item.mail.error" small color="error" class="mx-1" :title="item.mail.error">mdi-email-alert</v-icon>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="resendMail(item)">
																<v-list-item-title class="size9">Rinvia mail</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="confirmDelete(item)">
																<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center mb-1">
														<v-chip x-small dark :color="statusColor(item.status)">{{ statusLabel(item.status) }}</v-chip>
														<span v-if="minApplied(item)" class="text-caption orange--text text--darken-2 ml-2">&rarr; minimo garantito</span>
													</div>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense>
														<v-icon dark>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="resendMail(item)">
														<v-list-item-title class="size9">Rinvia mail</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="confirmDelete(item)">
														<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>
											<div class="font-weight-medium">{{ item.code }}</div>
											<div class="text-caption grey--text text--darken-1">{{ item.auto ? 'Automatico' : 'Manuale' }}</div>
										</td>
										<td>
											<div>{{ item.merchant && item.merchant.name ? item.merchant.name : '-' }}</div>
											<div class="text-caption grey--text text--darken-1">{{ item.merchant && item.merchant.email ? item.merchant.email : '-' }}</div>
										</td>
										<td>
											<div>{{ periodLabel(item) }}</div>
											<div class="text-caption grey--text text--darken-1">{{ item.months }} {{ item.months === 1 ? 'mese' : 'mesi' }}</div>
										</td>
										<td>{{ billingLabel(item.billingType) }}</td>
										<td>
											<div class="font-weight-medium">{{ formatEuro(item.amount) }}</div>
											<div v-if="item.billingType === 'commission'" class="text-caption grey--text text--darken-1">
												{{ item.value }}% su {{ formatEuro(item.orders && item.orders.total) }}
												<span v-if="minApplied(item)" class="orange--text text--darken-2">&rarr; minimo garantito</span>
											</div>
										</td>
										<td>
											<v-chip x-small dark :color="statusColor(item.status)">{{ statusLabel(item.status) }}</v-chip>
										</td>
										<td>{{ formatDate(item.paidAt) }}</td>
										<td>
											<v-icon v-if="item.mail && item.mail.sentAt" small color="success" :title="mailTitle(item)">mdi-email-check</v-icon>
											<v-icon v-else-if="item.mail && item.mail.error" small color="error" :title="item.mail.error">mdi-email-alert</v-icon>
											<span v-else>-</span>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>

					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog persistent v-model="dialogdelete" width="560px">
			<v-card>
				<v-card-title class="red lighten-5 py-4 title">
					<v-icon color="error" class="mr-2">mdi-alert-octagon</v-icon>
					Elimina pagamento
				</v-card-title>
				<v-card-text class="pt-4">
					<p class="mb-2">
						Stai per eliminare il pagamento <strong>{{ deleteTarget.code }}</strong> di <strong>{{ deleteTarget.name }}</strong
						>.
					</p>
					<p class="red--text mb-0">L'operazione è irreversibile.</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text :disabled="deleting" @click="dialogdelete = false">Annulla</v-btn>
					<v-btn color="error" :loading="deleting" @click.prevent="removePayment">Elimina</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormEdit v-if="operation === 'FormEdit'" :key="componentKey" @event="initialize(true)" @message="propSetMessages"></FormEdit>
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @event="initialize(true)" @message="propSetMessages"></FormCreate>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
import { statusItems, billingItems, statusLabel, statusColor } from '@/components/manage/payments/form';
import KeyValueCard from '@/components/core/KeyValueCard.vue';

const FormEdit = () => import('@/components/manage/payments/Edit.vue');
const FormCreate = () => import('@/components/manage/payments/Create.vue');

export default {
	name: 'PaymentsManage',
	components: { FormEdit, FormCreate, KeyValueCard },
	data() {
		return {
			// ricerca/filtri/paginazione: applicati lato server
			settings: {
				search: '',
				filters: {
					status: null,
					billingType: null,
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 25,
				},
			},
			// il campo di ricerca diventa `settings.search` solo al click sulla lente o con invio
			searchfield: '',
			total: 0,
			loading: false,
			billing: false,
			lastQuery: '',
			listSize: [15, 25, 50, 100],
			componentKey: 0,
			operation: '',
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Riferimento', value: 'code' },
				{ text: 'Merchant', value: 'merchant.name' },
				{ text: 'Periodo', value: 'period.to' },
				{ text: 'Tipo', value: 'billingType' },
				{ text: 'Importo', value: 'amount' },
				{ text: 'Status', value: 'status' },
				{ text: 'Pagato il', value: 'paidAt' },
				{ text: 'Mail', value: '', sortable: false },
			],
			statusItems: statusItems,
			billingItems: billingItems,
			dialogdelete: false,
			deleteTarget: { _id: '', code: '', name: '' },
			deleting: false,
			snackbar: {
				snackbar: false,
				color: '',
				mode: 'multi-line',
				timeout: 5000,
				text: '',
			},
		};
	},
	created() {
		this.initialize();
	},
	mounted() {
		this.setDialog(false);
	},
	watch: {
		// pagina, righe per pagina e ordinamento: ricaricano la pagina corrente
		'settings.options': {
			handler: function () {
				this.initialize();
			},
			deep: true,
		},
		// cambiando un filtro si riparte dalla prima pagina
		'settings.filters': {
			handler: function () {
				this.resetPageAndFetch();
			},
			deep: true,
		},
	},
	computed: {
		...mapGetters({
			getPayments: 'payments/getPayments',
			getDialog: 'settings/getDialog',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
	},
	methods: {
		...mapMutations({
			setDialog: 'settings/setDialog',
			setSelected: 'payments/setSelected',
		}),
		...mapActions({
			fetchPayments: 'payments/asyncFetchPayments',
			destroyPayment: 'payments/deletePayment',
			sendMail: 'payments/sendPaymentMail',
			runBilling: 'payments/runBilling',
		}),
		statusLabel: statusLabel,
		statusColor: statusColor,
		// messaggio di esito emesso dai form di creazione/modifica
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
		},
		// coppie chiave/valore della card da telefono
		campiCard(item) {
			const campi = [
				{ label: 'Merchant', value: item.merchant && item.merchant.name },
				{ label: 'Email', value: item.merchant && item.merchant.email },
				{ label: 'Periodo', value: this.periodLabel(item) },
				{ label: 'Mesi', value: item.months },
				{ label: 'Tipo', value: this.billingLabel(item.billingType) },
				{ label: 'Importo', value: this.formatEuro(item.amount), strong: true },
			];
			if (item.billingType === 'commission') {
				campi.push({ label: 'Commissione', value: `${item.value}% su ${this.formatEuro(item.orders && item.orders.total)}` });
			}
			campi.push({ label: 'Pagato il', value: this.formatDate(item.paidAt) });
			return campi;
		},
		billingLabel(value) {
			const found = this.billingItems.find(el => el.value === value);
			return found ? found.text : 'Fisso';
		},
		formatDate(value) {
			return value ? moment(value).format('DD/MM/YYYY') : '-';
		},
		formatEuro(value) {
			return `€ ${(Number(value) || 0).toFixed(2)}`;
		},
		// il minimo garantito ha fatto premio sulla percentuale: si ricalcola dallo snapshot del
		// pagamento, cosi' i documenti emessi prima del campo (senza `min`) restano invariati
		minApplied(item) {
			const min = Number(item.min) || 0;
			if (!min || item.billingType !== 'commission') return false;
			const total = Number((item.orders && item.orders.total) || 0);
			return min > Number(((total * (Number(item.value) || 0)) / 100).toFixed(2));
		},
		// `period.to` e' esclusa: a video si mostra l'ultimo giorno incluso
		periodLabel(item) {
			if (!item.period || !item.period.from || !item.period.to) return '-';
			return `${this.formatDate(item.period.from)} - ${moment(item.period.to).subtract(1, 'day').format('DD/MM/YYYY')}`;
		},
		mailTitle(item) {
			return `Inviata il ${this.formatDate(item.mail.sentAt)} a ${item.mail.to || '-'}`;
		},
		createItem() {
			this.componentKey += 1;
			this.operation = 'FormCreate';
			this.setSelected({});
			this.setDialog(true);
		},
		editItem(item) {
			if (!item) return;
			this.componentKey += 1;
			this.operation = 'FormEdit';
			this.setSelected(item);
			this.setDialog(true);
		},
		confirmDelete(item) {
			this.deleteTarget = { _id: item._id, code: item.code || '', name: (item.merchant && item.merchant.name) || '' };
			this.dialogdelete = true;
		},
		async removePayment() {
			this.deleting = true;
			try {
				await this.destroyPayment({ _id: this.deleteTarget._id });
				this.dialogdelete = false;
				this.snackbar.color = 'success';
				this.snackbar.text = `Pagamento ${this.deleteTarget.code} eliminato`;
				this.snackbar.snackbar = true;
				await this.initialize(true);
			} catch (err) {
				this.showError(err, 'Errore durante eliminazione del pagamento');
			} finally {
				this.deleting = false;
			}
		},
		async resendMail(item) {
			try {
				await this.sendMail({ _id: item._id });
				this.snackbar.color = 'success';
				this.snackbar.text = 'Mail inviata al merchant';
				this.snackbar.snackbar = true;
				await this.initialize(true);
			} catch (err) {
				this.showError(err, 'Errore durante invio della mail');
			}
		},
		// in produzione lo fa il cron delle 08:00: qui serve per provarlo o per un recupero
		async runManualBilling() {
			this.billing = true;
			try {
				const res = await this.runBilling();
				const summary = res && res.data ? res.data : { created: 0, scanned: 0 };
				this.snackbar.color = 'success';
				this.snackbar.text = `Fatturazione eseguita: ${summary.created} pagamenti creati su ${summary.scanned} profili scaduti`;
				this.snackbar.snackbar = true;
				await this.initialize(true);
			} catch (err) {
				this.showError(err, 'Errore durante la fatturazione');
			} finally {
				this.billing = false;
			}
		},
		showError(err, fallback) {
			this.snackbar.color = 'error';
			this.snackbar.text =
				(err.response && err.response.data && err.response.data.error && err.response.data.error[0] && err.response.data.error[0].msg) || fallback;
			this.snackbar.snackbar = true;
			if (err.response && err.response.status === 401) {
				this.$router.push('/login');
			}
		},
		// la ricerca parte solo dalla lente o con invio, non a ogni tasto
		getSearch() {
			this.settings.search = (this.searchfield || '').trim();
			this.resetPageAndFetch();
		},
		clearSearch() {
			this.searchfield = '';
			this.settings.search = '';
			this.resetPageAndFetch();
		},
		// se non siamo gia' in prima pagina ci pensa il watcher su settings.options a ricaricare
		resetPageAndFetch() {
			if (this.settings.options.page !== 1) {
				this.settings.options.page = 1;
				return;
			}
			this.initialize();
		},
		// `force` salta il dedupe (es. dopo una cancellazione, dove i parametri non cambiano)
		async initialize(force) {
			const { page, itemsPerPage, sortBy, sortDesc } = this.settings.options;
			const signature = JSON.stringify({ search: this.settings.search, filters: this.settings.filters, page, itemsPerPage, sortBy, sortDesc });
			// la v-data-table riemette le options al mount: senza questo controllo partirebbero due richieste
			if (!force && signature === this.lastQuery) {
				return;
			}
			this.lastQuery = signature;

			this.loading = true;
			try {
				const pagination = await this.fetchPayments(this.settings);
				this.total = pagination ? pagination.total : 0;
			} catch (err) {
				console.log(err);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.manage-payment-cards,
.manage-payment-cards tr {
	display: block;
	width: 100%;
}
.manage-payment-cards tr,
.manage-payment-cards tr:hover {
	background: transparent !important;
}
.manage-payment-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.manage-payment-cards tr:first-child td {
	padding-top: 12px !important;
}
.manage-payment-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.manage-payment-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
